require('./servants/course_requirement_servant');
require('./servants/course_requirement_tree');
require('./directives/add_attr.ts');



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-requisite-tree/src/core.ts